import { ActionList, actionList } from '@models/canvas-button-actions';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ButtonAction } from 'icreate/common/models/editor-viewer-element';

@Component({
    selector: 'app-button-element-actions',
    templateUrl: './button-element-actions.component.html',
    styleUrls: ['./button-element-actions.component.css'],
    standalone: false,
})
export class ButtonElementActionsComponent implements OnChanges {
    @Input() buttonAction: ButtonAction;
    @Output() onActionSelected: EventEmitter<ButtonAction> = new EventEmitter();
    actionList: ActionList[] = actionList;
    shouldShowActions: boolean = false;

    selectedAction: ActionList;

    ngOnChanges(changes: SimpleChanges): void {
        if (this.buttonAction) {
            this.selectedAction = actionList.find(action => action.action === this.buttonAction);
        }
    }

    actionSelected(selectedActionEvent) {
        if (selectedActionEvent.value) {
            this.selectedAction = selectedActionEvent.value;
            this.onActionSelected.emit(this.selectedAction.action);
        }
    }
}
